var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from "react-redux";
import { CssVarsProvider } from "@mui/joy";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import store from "@/store";
import { Suspense } from "react";
var persistor = persistStore(store);
export default function AppContextProvider(_a) {
    var children = _a.children;
    return (_jsx(CssVarsProvider, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(PersistGate, __assign({ loading: null, persistor: persistor }, { children: _jsx(Suspense, { children: children }) })) })) }));
}
